var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ModalStatus)?_c('div',{staticClass:"modal-view-c"},[_c('div',{staticClass:"modal-view-inner-wrapper"},[_c('section',{staticClass:"modal-view-header"},[_c('div',{staticClass:"popup-close-btn",on:{"click":_vm.handlerClosePopup}})]),_c('section',{staticClass:"modal-view-body"},[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }